import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import jsPDF from 'jspdf';

import { Filtro } from 'src/app/Models/filtro/filtro';
import { Personal } from 'src/app/Models/personal/personal';
import { DataService } from 'src/app/Service/data.service';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';
import { LoadingComponent } from '../objects/loading/loading.component';
import { AlertComponent } from '../objects/alert/alert/alert.component';

@Component({
  selector: 'app-print-reporte-gastos-detallado',
  templateUrl: './print-reporte-gastos-detallado.component.html',
  styleUrls: ['./print-reporte-gastos-detallado.component.css']
})
export class PrintReporteGastosDetalladoComponent implements OnInit {



  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  mes: string = '1';
  idvende: string = '1';
  public detfactus: any[] = [];
  totalcantidad: number = 0;
  totalefectivo: number = 0;
  totalfise: number = 0;
  totalyape: number = 0;
  totaltarjetacredito: number = 0;
  totalcredito: number = 0;
  totalgeneral: number = 0;
  public funcion: Function = null;
  public isShow: boolean = false;
  public personal: Personal = new Personal()
  public today = new Date();
  public fecinicio: any;
  public fecfin: any;
  public filtro: Filtro = new Filtro()
  public sucursal: number;

  constructor(private data: DataService, private reportViewer: ReportViewerService, private datePipe: DatePipe, private cdr: ChangeDetectorRef) {
    
    this.filtro.idsucursal = parseInt(this.data.getSucursalId());
    
  }


  ngOnInit() {
  }

  public show(affterfunction: Function = null) {
    this.funcion = affterfunction;
    this.isShow = true;
    this.setInitialDates();
    setTimeout(() => {
      this.btnshow.nativeElement.click();
    }, 10);
  }

  setInitialDates() {
    const today = new Date();
    this.filtro.fecfin = this.formatFecha(today, 'yyyy-MM-dd');

    // Obtener el primer día del mes
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.filtro.fecini = this.formatFecha(firstDayOfMonth, 'yyyy-MM-dd');

    console.log('Fechas iniciales establecidas:', this.filtro.fecini, this.filtro.fecfin);
  }

  GetData(filtro: Filtro) {
    this.data.Post('informe_gastos_detallado', filtro).subscribe({
      next: (r: any) => {
        console.log('Respuesta reporte por zonas:', r);
        if (r.message === "success") {
          this.fecinicio = filtro.fecini;
          this.fecfin = filtro.fecfin;
          this.cdr.detectChanges();

          setTimeout(() => {
            // Generar el PDF
            const blob = this.printerGastosDetallado(r.data);

            // Mostrar en el modal reutilizable
            if (blob) {
              const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
              this.reportViewer.mostrarPDF(
                blob,
                'Reporte Detallado de Gastos',
                `reporte_gastos_detallado_${fecha}.pdf`
              );
            }
          }, 0);
        } else {
          console.warn("No se pudo obtener datos. Mensaje:", r.message);
        }
      },
      error: (err: any) => {
        console.error("Error al obtener datos del reporte por zonas:", err);
      }
    });
  }

  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }

  printerGastosDetallado(gastosData: any[]): Blob | null {
    const doc = new jsPDF('portrait'); // Cambiado a portrait (vertical)
    const titulo = { text: 'REPORTE DETALLADO DE GASTOS', x: 70, y: 20 };
    const addHeader = () => {
      doc.setFontSize(12);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);
      const lineY = titulo.y + 1;
      doc.setLineWidth(0.5);
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(8);
      doc.text(
        `Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`,
        10,
        28
      );
      doc.text(
        `Generado el día ${this.formatFecha(this.today, 'dd-MM-yyyy HH:mm')}`,
        140,
        28
      );
      doc.setFontSize(9);
    };
    // Preparar datos para la tabla
    const tableRows: any[] = [];
    let totalGeneral = 0;
    gastosData.forEach((gasto: any) => {
      const row: any[] = [];
      row.push(gasto.idgasto || '');
      row.push(gasto.fecha ? this.formatFecha(new Date(gasto.fecha), 'dd-MM-yyyy') : '');
      row.push(gasto.hora || '');
      row.push(gasto.vendedor || 'SIN NOMBRE');
      row.push(gasto.concepto || '');
      row.push(gasto.tipo_gasto || '');
      row.push(gasto.total ? Number(gasto.total).toFixed(2) : '0.00');
      totalGeneral += (gasto.total || 0);
      tableRows.push(row);
    });
    // Agregar fila de total
    const rowTotal: any[] = [];
    rowTotal.push('');
    rowTotal.push('');
    rowTotal.push('');
    rowTotal.push('');
    rowTotal.push('');
    rowTotal.push('TOTAL GENERAL');
    rowTotal.push(totalGeneral.toFixed(2));
    tableRows.push(rowTotal);
    // Configurar encabezados de la tabla
    const headers = [
      { content: 'ID', styles: { halign: 'center' } },
      { content: 'FECHA', styles: { halign: 'center' } },
      { content: 'HORA', styles: { halign: 'center' } },
      { content: 'VENDEDOR', styles: { halign: 'center' } },
      { content: 'CONCEPTO', styles: { halign: 'center' } },
      { content: 'TIPO', styles: { halign: 'center' } },
      { content: 'MONTO', styles: { halign: 'center' } }
    ];
    // Configurar estilos de columnas (ajustado para portrait)
    const columnStyles: any = {
      0: { halign: 'center', cellWidth: 12 },
      1: { halign: 'center', cellWidth: 22 },
      2: { halign: 'center', cellWidth: 15 },
      3: { halign: 'left', cellWidth: 35 },
      4: { halign: 'left', cellWidth: 55 },
      5: { halign: 'left', cellWidth: 25 },
      6: { halign: 'right', cellWidth: 20 }
    };
    (doc as any).autoTable({
      head: [headers],
      body: tableRows,
      startY: 32,
      margin: { horizontal: 5 },
      theme: 'grid',
      columnStyles,
      styles: {
        fontSize: 7,
        cellPadding: 1.5,
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: [200, 200, 200],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        fontSize: 7
      },
      didParseCell: (data: any) => {
        // Resaltar la fila de totales
        if (data.row.index === tableRows.length - 1 && data.section === 'body') {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.fillColor = [240, 240, 240];
        }
      },
      didDrawPage: (data: any) => {
        addHeader();
        const pageNumber = data.pageNumber;
        doc.text(`Página ${pageNumber}`, 180, 15);
      }
    });
    // Retornar el blob
    return doc.output('blob');
  }

  close() {
    this.btnclose.nativeElement.click();
  }


}
